const processButtonText = (element) => {
    const x = document.createElement('div')
    x.innerHTML = element
    return x.querySelector('p') ? x.querySelector('p').innerHTML : element
}

export default processButtonText
